import feesService from '../services/fees-service'

export const zonesQuery = () => ({
  queryKey: ['zones'],
  queryFn: () => feesService.getZones()
})
